import InsideModalConfirmation from './InsideModalConfirmation';

export default InsideModalConfirmation;
